import { 
  ResetPasswordChangeModel, 
} from './reset-password-change.model';

import { BaseClass } from '../Base/base.class';
import { dropProps } from '../Base/base.class';
import { InputModel } from '../Form/InputField/input.model';
import { InputClass } from '../Form/InputField/input.class';

import { resetPasswordChangeFormData } from './reset-password-change.data';

export class ResetPasswordChangeClass extends BaseClass<ResetPasswordChangeModel> implements ResetPasswordChangeModel {
  get password(): InputModel {
    return dropProps(this.props.password, new InputClass(this.props.password)); 
  }
  get repeatPassword(): InputModel {
    return dropProps(this.props.repeatPassword, new InputClass(this.props.repeatPassword)); 
  }
}

export const resetPasswordChangeFormValues = () => resetPasswordChangeFormData && dropProps(
  resetPasswordChangeFormData(), 
  new ResetPasswordChangeClass(resetPasswordChangeFormData())
);
